import DivContainerBody from '../../../../../components/DivContainerBody';
import Subtitle from '../../../../../components/Header/Subtitle';
import ButtonSubAction from '../../../../../components/buttons/ButtonSubAction';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { AddIcon, TrashOutlineIcon } from '../../../../../components/buttons/IconButtons';
import ManageRoleModal from '../Modal/ManageRoleModal';
import DeleteModal from '../../../../Modals/DeleteModal';
import PrivilegeDetailsApp from '../Functionality/PrivilegeDetailsApp';
import { permissionObj } from '../../../../../Helpers/permission';
import CustomTable from '../../../../../components/table/CustomTable';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 *  @param  t Function - The translation function used to handle internationalization.
 * @param  DEV boolean - A flag indicating if the application is in development mode, which gives additional privileges.
 * @param  permission Array<string> - A list of permissions associated with the current user.
 * @param  permissionObj Object - The object containing various permission identifiers.
 * @param  item Object - The current item (e.g., role or privilege) for which the users are being managed.
 *
 */
const PrivilegeDetails = ({ row }) => {
    const {
        handleCheckboxChange,
        handleDeleteAll,
        deleteUsers,
        pagination,
        DEV,
        permission,
        thead,
        tbody,
        tableId,
        selectedList,
        setSelectedList,
        modified,setModified,
        showModal,
        setShowModal,
        manageShow,
        setManageShow,
        isAllChecked,
        setIsAllChecked,
    } = PrivilegeDetailsApp(row?.id);
    return (
        <>
            {(DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_MANAGE_USERS)) && (
                <Subtitle
                    name={'assgined_employees'}
                    table='true'
                    divStack={
                        <>
                            <ButtonSubAction
                                id='btn_pd_manage'
                                name='manage_users'
                                Icon={AddIcon}
                                onClick={() => setManageShow(true)}
                            />
                        </>
                    }
                >
                    {selectedList?.length > 0 && (
                        <ButtonAction
                            id='btn_pd_delete'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectedList?.length === 0}
                            Icon={TrashOutlineIcon}
                            onClick={() => setShowModal(true)}
                            splitName={false}
                        />
                    )}
                </Subtitle>
            )}
            <DivContainerBody>
                <>
                    <CustomTable
                        tableId={tableId}
                        checkbox={DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_MANAGE_USERS)}
                        checkboxTitle={'de_/_select_all'}
                        isAllChecked={isAllChecked}
                        thead={thead}
                        tbody={tbody}
                        columnActions={false}
                        onChangeCheckbox={handleDeleteAll}
                        handleCheckboxChange={handleCheckboxChange}
                        selectedList={selectedList}
                        withoutHeight={true}
                    />
                    {pagination()}
                </>
            </DivContainerBody>

            {manageShow &&
                <ManageRoleModal
                    show={manageShow}
                    onHide={() => setManageShow(false)}
                    selectedId={row?.id}
                    setModified={setModified}
                    modified={modified}
                />
            }

            <DeleteModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onClickFn={() => deleteUsers(selectedList)}
                data={selectedList}
                title_modal={'privilege'}
                element_modal={'assigned_employees'}
                isReset={setSelectedList}
            />
        </>
    );
};

export default PrivilegeDetails;
